import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GenericService {
  allMonth = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  constructor() {}

  public get getTodaysDate() {
    return new Date();
  }

  // 0 will get January
  getCurrentMonth() {
    return this.allMonth[this.getTodaysDate.getMonth()];
  }

  // January will get 0
  getCurrentMonthInNumber(monthName: string) {
    return this.allMonth.indexOf(monthName) + 1;
  }
}
